<template lang="pug">
    v-flex.main-filter()

        v-flex.main-filter__date-container
            v-btn-toggle.main-filter__button-row.main-filter__button-row--right.mr-2(shaped, borderless, v-model="preset")
                v-btn( value="today" small active-class='primary' ).mx-1
                    |HOY
                    v-icon
                v-btn( value="week" small active-class='primary').mx-1
                    |ESTA SEMANA
                    v-icon
                v-btn( value="month"  small active-class='primary').mx-1
                    |ESTE MES
                    v-icon
            v-layout.main-filter__input-container
                v-flex.main-filter__date-pickers
                    v-flex.main-filter__date
                        v-menu(v-model="modalDateFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y="" min-width="290px")
                          template(v-slot:activator="{ on }")
                              v-text-field(:value="dateFromFormated" label="Fecha de inicio" prepend-icon="mdi-calendar" readonly="" v-on="on")
                          v-date-picker(v-if="modalDateFrom" v-model="dateFrom" @input="modalDateFrom = false")
                    v-flex.main-filter__date
                        v-menu(v-model="modalDateTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y="" min-width="290px")
                          template(v-slot:activator="{ on }")
                              v-text-field(:value="dateToFormated" label="Fecha de fin" prepend-icon="mdi-calendar" readonly="" v-on="on")
                          v-date-picker(v-if="modalDateTo" v-model="dateTo" @input="modalDateTo = false")
                v-btn.main-filter__refresh-btn.ma-2(:loading='isLoading', :disabled='isLoading' small color='success', @click="filterByDate" )

                    v-icon( small) mdi-cached
                    |Filtrar
                    template(v-slot:loader='')
                        span.custom-loader
                            v-icon(light='' small) mdi-cached

</template>

<script>
  // import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'DateFilter',
    props: {
      currentType: String,
    },
    data () {
      return {
        preset: 'week',
        modalDateFrom: false,
        modalDateTo: false,
        menu: false,
        modal: false,
        menu2: false,
        dateFrom: '',
        dateTo: '',
        dateToFormated: '',
        dateFromFormated: '',
        showMessageDate: false,
      }
    },
    computed: {
      isLoading () {
        return false
      },
      // ...mapState(['isLoading']),
    },
    watch: {
      currentType (newVal, oldVal) {
        this.filterByDate()
      },
      preset (newVal, oldVal) {
        this.filterByDatePreset(newVal)
      },
      dateFrom (val) {
        this.dateFromFormated = moment(val).format('DD-MM-YYYY')
        // this.dateFromFormated = this.formatDate(this.dateFrom)
      },
      dateTo (val) {
        this.dateToFormated = this.formatDate(this.dateTo)
      },
    },
    mounted () {
      const vm = this
      vm.dateFrom = moment().subtract(6, 'days').format('YYYY-MM-DD')
      vm.dateTo = moment().add(1, 'days').format('YYYY-MM-DD')
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, false]).then(function () {

        })
      },
      filterByDate () {
        const vm = this
        // console.log(vm.currentType)
        if (vm.currentType !== 'loadFilteredSummary' && vm.currentType !== 'sales' && vm.currentType !== 'purchases') {
          vm.loadLog(vm.currentType, moment(vm.dateFrom).format('YYYY-MM-DD'), moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD'))
        }
        const emittedDates = { from: moment(vm.dateFrom).format('YYYY-MM-DD'), to: moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD') }
        vm.$emit('closeMenu', emittedDates)
      },
      filterByDatePreset (val) {
        const vm = this
        switch (val) {
          case 'today':
            vm.dateFrom = moment().format('YYYY-MM-DD')
            vm.dateTo = moment().add(1, 'd').format('YYYY-MM-DD')
            break
          case 'week':
            vm.dateFrom = moment().startOf('isoWeek').format('YYYY-MM-DD')
            vm.dateTo = moment().endOf('isoWeek').format('YYYY-MM-DD')
            break
          case 'month':
            vm.dateFrom = moment().startOf('month').format('YYYY-MM-DD')
            vm.dateTo = moment().endOf('month').format('YYYY-MM-DD')
            break
        }
        if (vm.currentType !== 'loadFilteredSummary' && vm.currentType !== 'sales' && vm.currentType !== 'purchases') {
          this.loadLog(vm.currentType, vm.dateFrom, moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD'))
        }
        const emittedDates = { from: moment(vm.dateFrom).format('YYYY-MM-DD'), to: moment(vm.dateTo).add(1, 'days').format('YYYY-MM-DD') }
        vm.$emit('closeMenu', emittedDates)

        // if(dateFrom !== ''){
        //     this.loadLog(vm.currentType,  vm.dateFrom, moment(vm.dateTo).add(1,'days').format('YYYY-MM-DD'));
        // }else{
        //     this.loadLog(vm.currentType,  moment(vm.dateTo).subtract(30,'days').format('YYYY-MM-DD'), moment(vm.dateTo).add(1,'days').format('YYYY-MM-DD'));
        // }
        // vm.$store.dispatch('loadLog', [vm.currentType, moment(vm.dateFrom).format('YYYY-MM-DD'), moment(vm.dateTo).format('YYYY-MM-DD')]).then(()=>{
        //     // vm.$store.commit('setLoading',false);
        //     // vm.setPages();
        // });
      },
    },
  }
</script>

<!--<style scoped lang="scss">-->
    <!--// New Breakpoints-->
    <!--@import '@/styles/custom/mixins.scss';-->
    <!--.main-filter{-->
        <!--display: flex;-->
        <!--flex-direction: row;-->
        <!--margin: auto;-->
        <!--max-width: 700px;-->

        <!--&__button-row{-->
            <!--box-shadow: none;-->
            <!--&&#45;&#45;left{-->
                <!--display: flex;-->
                <!--flex-direction: column;-->
                <!--margin-right: 2px;-->

                <!--button{-->
                    <!--flex: 1;-->
                <!--}-->
            <!--}-->
            <!--&&#45;&#45;right{-->
                <!--flex-direction: column;-->
                <!--width: 100%;-->
                <!--@include break-up("phablet"){-->
                    <!--width: 500px;-->
                    <!--flex-direction: row;-->
                    <!--button{-->
                        <!--flex:1;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--button{-->

            <!--}-->
        <!--}-->
        <!--&__input-container{-->
            <!--margin: auto !important;-->
            <!--width: 100%;-->
            <!--display: flex;-->
            <!--flex-direction: column;-->
            <!--align-items: flex-start;-->
            <!--flex-wrap: wrap;-->
            <!--@include break-up('phablet'){-->
                <!--flex-direction:row;-->
                <!--align-items: center;-->
            <!--}-->
        <!--}-->
        <!--&__date-pickers{-->
            <!--display: flex;-->
            <!--flex-direction: column;-->

            <!--@include break-up('phablet'){-->
                <!--flex-direction:row;-->
                <!--max-width: 400px;-->
            <!--}-->
        <!--}-->
        <!--&__date{-->
            <!--@include break-up('phablet'){-->

            <!--}-->

            <!--display: flex;-->
            <!--flex-direction: column;-->
            <!--align-items: center;-->
            <!--justify-content: center;-->
            <!--margin: 10px;-->
        <!--}-->
        <!--&__date-container{-->
            <!--flex: 1;-->
        <!--}-->
        <!--&__refresh-btn {-->
            <!--width: 100px !important;-->
        <!--}-->
    <!--}-->
    <!--.custom-loader {-->
        <!--animation: loader 1s infinite;-->
        <!--display: flex;-->
    <!--}-->
    <!--@-moz-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@-webkit-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@-o-keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
    <!--@keyframes loader {-->
        <!--from {-->
            <!--transform: rotate(0);-->
        <!--}-->
        <!--to {-->
            <!--transform: rotate(360deg);-->
        <!--}-->
    <!--}-->
<!--</style>-->
